// extracted by mini-css-extract-plugin
module.exports = {"wrap":"List_wrap__k_TcM","list":"List_list__49m6r","listRow":"List_listRow__ev9O0"};